import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
// component
import MNPG from "@/components/MainPageLayouts/components/MNPG";
// hooks
import useMainPageItems from "@/hooks/useMainPageItems";
import useSEO from "@/hooks/useSEO";
// types
import TContent from "./type";
// enums
import TOutletContext from "@/cms/types/TOutletContext";


const Render = ( props:any ) => {

    useSEO(props.locals);

    return (<MNPG templates={props.pageTemplates} mapLayoutName={"MNPGGRP_004"} contentId={props.contentId}  />)
}

const Content = ( props:TContent ) => {
    console.log("Content.rendered: ", props);

    const { contentId, webApplicationLanguageISOCode, _showLoader, _viewEvent } = useOutletContext<TOutletContext>();
    const pageTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_004"});

    useEffect (() => { _viewEvent(contentId); return () => { _showLoader(); } }, [contentId]);


    if ( !contentId || !pageTemplates ) return null;

    return (<Render pageTemplates={pageTemplates} contentId={contentId} locals={{language:webApplicationLanguageISOCode, type:"null", id:contentId}} />)
}

export default Content;
